import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { inventoryActions } from "../../sagas/inventorySlice";
import {
  Container, Row, Col, Card, CardBody, Button,
  Table, Form, FormGroup, Label, Input, Spinner
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { FaClipboardCheck, FaClipboardList, FaPlus } from "react-icons/fa";

const InventoryListPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { inventories, loading, totalPages, pageNumber } = useSelector(state => state.inventory);

  const [filters, setFilters] = useState({
    entrepotId: "",
    status: "",
    dateFrom: "",
    dateTo: "",
    page: 0,
    size: 10
  });

  useEffect(() => {
    dispatch(inventoryActions.searchInventories(filters));
  }, [filters.page]);

  const handleSearch = () => {
    dispatch(inventoryActions.searchInventories({ ...filters, page: 0 }));
  };

  const handleValidate = (id) => {
    Swal.fire({
      title: "Valider l’inventaire ?",
      text: "Le stock sera ajusté automatiquement.",
      icon: "warning",
      showCancelButton: true,
    }).then((res) => {
      if (res.isConfirmed) {
        dispatch(inventoryActions.validateInventory({
          id,
          onSuccess: () => handleSearch()
        }));
      }
    });
  };

  return (
    <Container fluid>

      <Row className="mb-4">
        <Col>
          <Card className="shadow-sm">
            <CardBody className="d-flex justify-content-between align-items-center">
              <h4 className="mb-0 d-flex align-items-center">
                <FaClipboardCheck className="text-primary me-2" />
                Inventaires
              </h4>
              <div className="d-flex align-items-center gap-2">
                <Button color="success" onClick={() => navigate("/inventories/new")}>
                  <FaPlus className="me-1" /> Nouvel inventaire
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <CardBody>

              {/* 🔍 SEARCH BLOCK */}
              <Form>
                <Row>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Entrepôt</Label>
                      <Input type="text"
                        onChange={e => setFilters({ ...filters, entrepotId: e.target.value })} />
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <FormGroup>
                      <Label>Status</Label>
                      <Input type="select"
                        onChange={e => setFilters({ ...filters, status: e.target.value })}>
                        <option value="">Tous</option>
                        <option value="EN_COURS">En cours</option>
                        <option value="VALIDE">Validé</option>
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <Label>Date début</Label>
                    <Input type="date"
                      onChange={e => setFilters({ ...filters, dateFrom: e.target.value })} />
                  </Col>

                  <Col md={3}>
                    <Label>Date fin</Label>
                    <Input type="date"
                      onChange={e => setFilters({ ...filters, dateTo: e.target.value })} />
                  </Col>
                </Row>


              </Form>

              <hr />

              {/* 📋 TABLE */}
              {loading ? <Spinner /> : (
                <Table bordered hover>
                  <thead>
                    <tr>
                      <th>Numéro</th>
                      <th>Date</th>
                      <th>Entrepôt</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inventories.map(inv => (
                      <tr key={inv.id}>
                        <td>{inv.numero}</td>
                        <td>{inv.dateInventaire}</td>
                        <td>{inv.entrepotNom}</td>
                        <td>
                          {inv.status === "EN_COURS" && (
                            <span className="badge bg-warning text-dark">
                              Inventaire en cours
                            </span>
                          )}

                          {inv.status === "VALIDE" && (
                            <span className="badge bg-success">
                              Inventaire validé
                            </span>
                          )}

                          
                        </td>
                        <td>
                          <Button size="sm" onClick={() => navigate(`/inventories/edit/${inv.id}`)}>Modifier</Button>{" "}
                          {inv.status === "EN_COURS" &&
                            <Button size="sm" color="warning"
                              onClick={() => handleValidate(inv.id)}>Valider</Button>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}

            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default InventoryListPage;
